import bgImage from "../../../assets/images/contacto/contenedor.png";
import redTruckImage from "../../../assets/images/contacto/camion rojo.png";
import phoneIcon from "../../../assets/images/contacto/icono_telefono.png";
import whatsappIcon from "../../../assets/images/contacto/icono_whatsapp.png";
import mailIcon from "../../../assets/images/contacto/icono_correo.png";
import locationIcon from "../../../assets/images/contacto/icono_phone.png";

import styles from "./SectionMediosContact.module.css";

const SectionMediosContact = () => {
  return (
    <section>
      <div className={styles.wrapper}>
        <img
          src={bgImage}
          className={styles.backgroundImage}
          alt="Fondo"
          loading="lazy"
        />

        <div className={`row ${styles.contentRow}`}>
          <div className={`col-12 col-lg-7 ${styles.leftCol}`}>
            <div
              className="my-5"
              style={{
                maxWidth: 753, // permite que el texto se reduzca sin recortar
                width: "100%", // ocupa el espacio disponible
                textAlign: "center",
                color: "white",
                fontSize: 48,
                fontFamily: "Nunito Sans",
                fontStyle: "italic",
                fontWeight: "700",
                wordWrap: "break-word", // ya no es tan necesario, pero lo dejamos por compatibilidad
                lineHeight: "1.2",
              }}
            >
              Nuestros medios de contacto
            </div>

            <img
              src={redTruckImage}
              alt="Camión rojo"
              className={styles.redTruckImage}
              loading="lazy"
            />
          </div>

          <div className={`col-12 col-lg-5 ${styles.rightCol}`}>
            {/* WhatsApp */}
            <div className={styles.phoneRow}>
              <img
                src={phoneIcon}
                className={styles.icon}
                alt="WhatsApp"
                loading="lazy"
              />
              <div className={styles.phoneBox}>81 2724 9484</div>
            </div>

            {/* WhatsApp */}
            <div className={styles.phoneRow}>
              <img
                src={whatsappIcon}
                className={styles.icon}
                alt="WhatsApp"
                loading="lazy"
              />
              <div className={styles.phoneBox}>81 2724 9484</div>
            </div>

            {/* Email */}
            <div className={styles.phoneRow}>
              <img
                src={mailIcon}
                className={styles.icon}
                alt="Email"
                loading="lazy"
              />
              <div className={styles.phoneBox}>
                ventas@revistaelindustrial.mx
              </div>
            </div>

            {/* Dirección */}
            <div className={styles.phoneRow}>
              <img
                src={locationIcon}
                className={styles.icon}
                alt="Dirección"
                loading="lazy"
              />
              <div className={styles.phoneBox}>Monterrey, N.l.</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionMediosContact;
